// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"b1e7a2a5","247":"9f283dd5","422":"90d927d8","484":"f3128f7e","551":"394339a3","627":"d2252665","653":"471b7718","834":"c1381f93","867":"83e9d8d2","923":"1bbfa5d5","938":"7fdb2709"}[chunkId] + ".chunk.js";
};